/* src/app/builder-screen-beta/components/spreadsheet/spreadsheet.component.scss */
.custom-spreadsheet-wrapper {
  display: flex;
  flex-direction: column;
  height: 100%;
  border: 1px solid #d9d9d9;
  border-radius: 6px;
  overflow: hidden;
  background-color: #ffffff;
}
.custom-spreadsheet-wrapper .spreadsheet-toolbar {
  padding: 8px 12px;
  border-bottom: 1px solid #f0f0f0;
  background-color: #fafafa;
  flex-shrink: 0;
}
.custom-spreadsheet-wrapper .spreadsheet-toolbar button {
  margin-right: 4px;
}
.custom-spreadsheet-wrapper .spreadsheet-formula-bar {
  padding: 8px 12px;
  border-bottom: 1px solid #f0f0f0;
  background-color: #ffffff;
  flex-shrink: 0;
}
.custom-spreadsheet-wrapper .custom-spreadsheet-container {
  flex: 1;
  overflow: auto;
  position: relative;
  min-height: 400px;
}
.custom-spreadsheet-wrapper .custom-spreadsheet-container .spreadsheet-table {
  width: 100%;
  border-collapse: separate;
  border-spacing: 0;
  font-family:
    "Segoe UI",
    Tahoma,
    Geneva,
    Verdana,
    sans-serif;
  font-size: 12px;
}
.custom-spreadsheet-wrapper .custom-spreadsheet-container .spreadsheet-table thead {
  position: sticky;
  top: 0;
  z-index: 10;
  background-color: #f5f5f5;
}
.custom-spreadsheet-wrapper .custom-spreadsheet-container .spreadsheet-table .row-header {
  background-color: #f5f5f5;
  border: 1px solid #e8e8e8;
  text-align: center;
  font-weight: 500;
  color: #262626;
  padding: 4px 8px;
  min-width: 40px;
  width: 40px;
  position: sticky;
  left: 0;
  z-index: 5;
}
.custom-spreadsheet-wrapper .custom-spreadsheet-container .spreadsheet-table .column-header {
  background-color: #f5f5f5;
  border: 1px solid #e8e8e8;
  text-align: center;
  font-weight: 500;
  color: #262626;
  padding: 4px 8px;
  min-width: 80px;
}
.custom-spreadsheet-wrapper .custom-spreadsheet-container .spreadsheet-table .spreadsheet-cell {
  border: 1px solid #e8e8e8;
  padding: 0;
  margin: 0;
  position: relative;
  background-color: #ffffff;
}
.custom-spreadsheet-wrapper .custom-spreadsheet-container .spreadsheet-table .spreadsheet-cell:hover {
  background-color: #f0f9ff;
}
.custom-spreadsheet-wrapper .custom-spreadsheet-container .spreadsheet-table .spreadsheet-cell.selected {
  background-color: #e6f7ff;
  border-color: #1890ff;
  box-shadow: inset 0 0 0 1px #1890ff;
}
.custom-spreadsheet-wrapper .custom-spreadsheet-container .spreadsheet-table .spreadsheet-cell.editing {
  background-color: #ffffff;
  border-color: #52c41a;
  box-shadow: inset 0 0 0 2px #52c41a;
}
.custom-spreadsheet-wrapper .custom-spreadsheet-container .spreadsheet-table .spreadsheet-cell .cell-input {
  border: none;
  outline: none;
  padding: 4px 6px;
  background: transparent;
  font-family: inherit;
  font-size: inherit;
  color: #262626;
  width: 100%;
  height: 100%;
  box-sizing: border-box;
}
.custom-spreadsheet-wrapper .custom-spreadsheet-container .spreadsheet-table .spreadsheet-cell .cell-input:focus {
  background-color: #ffffff;
}
.custom-spreadsheet-wrapper .custom-spreadsheet-container .spreadsheet-table .spreadsheet-cell .cell-input[readonly] {
  background-color: #f5f5f5;
  color: #8c8c8c;
  cursor: not-allowed;
}
.custom-spreadsheet-wrapper .spreadsheet-loading {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: rgba(255, 255, 255, 0.8);
  z-index: 1000;
}
@media (max-width: 768px) {
  .custom-spreadsheet-wrapper .spreadsheet-toolbar {
    padding: 6px 8px;
  }
  .custom-spreadsheet-wrapper .spreadsheet-toolbar button {
    font-size: 12px;
    padding: 0 8px;
  }
  .custom-spreadsheet-wrapper .spreadsheet-formula-bar {
    padding: 6px 8px;
  }
  .custom-spreadsheet-wrapper .spreadsheet-formula-bar input {
    font-size: 12px;
  }
  .custom-spreadsheet-wrapper .custom-spreadsheet-container .spreadsheet-table {
    font-size: 11px;
  }
  .custom-spreadsheet-wrapper .custom-spreadsheet-container .spreadsheet-table .row-header,
  .custom-spreadsheet-wrapper .custom-spreadsheet-container .spreadsheet-table .column-header {
    padding: 2px 4px;
    min-width: 30px;
  }
  .custom-spreadsheet-wrapper .custom-spreadsheet-container .spreadsheet-table .spreadsheet-cell .cell-input {
    padding: 2px 4px;
  }
}
.custom-spreadsheet-container::-webkit-scrollbar {
  width: 12px;
  height: 12px;
}
.custom-spreadsheet-container::-webkit-scrollbar-track {
  background: #f1f1f1;
  border-radius: 6px;
}
.custom-spreadsheet-container::-webkit-scrollbar-thumb {
  background: #c1c1c1;
  border-radius: 6px;
}
.custom-spreadsheet-container::-webkit-scrollbar-thumb:hover {
  background: #a8a8a8;
}
.custom-spreadsheet-container::-webkit-scrollbar-corner {
  background: #f1f1f1;
}
@media print {
  .custom-spreadsheet-wrapper .spreadsheet-toolbar,
  .custom-spreadsheet-wrapper .spreadsheet-formula-bar {
    display: none;
  }
  .custom-spreadsheet-wrapper .custom-spreadsheet-container {
    overflow: visible;
  }
  .custom-spreadsheet-wrapper .custom-spreadsheet-container .spreadsheet-table .spreadsheet-cell {
    border: 1px solid #000;
  }
  .custom-spreadsheet-wrapper .custom-spreadsheet-container .spreadsheet-table .spreadsheet-cell .cell-input {
    border: none;
    background: transparent;
  }
}
/*# sourceMappingURL=spreadsheet.component.css.map */
